const { prototype } = require("sortablejs");

// 請求先 is auto-filled only until it has been edited. Once the user (or the saved project) has set it,
// even by clearing it, it is never filled again. While untouched it may follow the 顧客 change.
function canAutoFillSendingPlace(currentId, autoFilledId, userEdited) {
  if (userEdited) return false;
  if (!currentId) return true;
  return autoFilledId != null && String(autoFilledId) === String(currentId);
}

$(function () {
  // if (!$('#project_billing_start_month').closest('.input-clearable').find('.clear-icon').is(':visible')) {
  //   $('.project-form').val('');
  // }

  var url = new URL(window.location.href);
  var searchParams = new URLSearchParams(url.search);
  if (!searchParams.has('current_tab') || searchParams.get('current_tab').trim() === '') {
    $('.edit-project-form .wrap-tab-pane li').first().find('a').tab('show')
  }

  $('#project_contract_start_at').on('apply.daterangepicker', function (ev, picker) {
    let format = $(this).data('format') || 'YYYY/MM/DD';
    var value = picker.startDate.format(format);
    $("#project_billing_start_month").val(picker.startDate.format('YYYY/MM')).trigger('change');
    $('#project_billing_start_month').data('daterangepicker').setStartDate(value);


    $(this).val(value);
    $('#project_contract_end_at').daterangepicker({
      locale: ja_date_locale,
      singleDatePicker: true,
      autoUpdateInput: false,
      autoApply: true,
      startDate: value,
      showDropdowns: false,
      minViewMode: 'months',
      minDate: value,
    });
    $('#project_contract_end_at').val('')
    $('#project_contract_end_at').on('apply.daterangepicker', function (ev, picker) {
      let format = $(this).data('format') || 'YYYY/MM/DD';
      $(this).val(picker.startDate.format(format));
      $('#project_contract_end_at').closest('.input-clearable').find('.clear-icon').css('display', 'inline');
    });
    $('#project_billing_start_month').closest('.input-clearable').find('.clear-icon').css('display', 'inline');
  });

  $('#project_contract_end_at').on('apply.daterangepicker', function (ev, picker) {
    let format = $(this).data('format') || 'YYYY/MM/DD';
    $(this).val(picker.startDate.format(format));
    $('#project_contract_end_at').closest('.input-clearable').find('.clear-icon').css('display', 'inline');
  });

  if ($('.edit-project-form').length > 0) {
    const PROJECT_ATTRS = [
      // 'name',
      // 'status',
      // 'note',
      // 'project_project_type_continue',
      // 'parent_project_id',
      // 'contracted_at',
      // 'company_id',
      // 'start_at',
      // 'department_id',
      // 'estimated_deliver_at',
      // 'completed_at',
      // 'deliver_at',
      // 'assigned_worker_ids',
      // 'transaction_status',
      // 'sending_place_id',
      // 'contract_start_at',
      // 'contract_end_at',
      // 'project_payment_period_monthly',
      // 'payment_type',
      // 'contact_location',
      // 'project_info',
    ];
    const PROJECT_ID = $('.table-plan-result').data('project-id');
    let $settingPlanModal = $('#setting-plan-project');
    let $planForm = $('.form-create-edit-plan');
    let $confirmDestroyPlanModal = $('#confirm-destroy-plan');

    var workerIds = $(".form-show-project").data("worker-ids");
    if (workerIds) {
      $(".project-page.assign-worker-id").val(workerIds).trigger("change")
    }

    toggleForm(true);

    $('.btn-edit-project').on('click', function () {
      $(this).addClass('d-none');
      $('.btn-save-project').removeClass('d-none');
      toggleForm(false);
    });

    $(".form-show-project").find("tr").addClass("setting-height");

    function toggleForm(ediableForm) {
      _.each(PROJECT_ATTRS, function (attr) {
        if (ediableForm) {
          $(`#${attr}`).closest('.form-group').addClass('d-none');
          $('#is_parent').prop('disabled', true);
          $(`.display-${attr}`).removeClass('d-none');
        } else {
          $(`#${attr}`).closest('.form-group').removeClass('d-none');
          $(`.display-${attr}`).addClass('d-none');
          $('#is_parent').prop('disabled', false);
        }
      });
      if (ediableForm) {
        $(".form-show-project").find("tr").addClass("setting-height");
      } else {
        $(".form-show-project").find("tr").removeClass("setting-height");
      }
    }

    $settingPlanModal.on('hidden.bs.modal', function () {
      $settingPlanModal.find('.js-save-account-plan').prop('disabled', false);
    });

    $('.setting-plan').on('click', function () {
      $settingPlanModal.find('.title').text('予定登録');
      $settingPlanModal.find('.submit-plan-text').text('登録');
      $planForm.attr('method', 'POST');
      $settingPlanModal.attr('project_account_plan_id', '');
      $settingPlanModal.find('.js-save-account-plan').prop('disabled', false);
      $settingPlanModal.modal('show');
    });

    $('#setting-plan-project .js-save-account-plan').on('click', function () {
      var $submitBtn = $(this);
      if ($submitBtn.prop('disabled')) return;

      resetPlanForm();
      let projectPlanId = $settingPlanModal.attr('project_account_plan_id');
      let isEdit = !!projectPlanId;
      let planFormData = $planForm.serialize();
      let url = $planForm.attr('action');
      if (isEdit) {
        url = `/projects/${PROJECT_ID}/project_account_plans/${projectPlanId}`;
      }

      $submitBtn.prop('disabled', true);

      $.ajax({
        url: url,
        method: $planForm.attr('method'),
        data: planFormData,
        success: function (res) {
          if (res.status) {
            window.location.href = `/projects/${PROJECT_ID}/edit`;
          } else {
            $submitBtn.prop('disabled', false);
            let errors = res.errors;
            _.each(errors, function (plan_errors, attr) {
              var $inputElement = $planForm.find("[name$='[" + attr + "]']");
              if (attr == 'account_type') {
                let $wrapElm = $inputElement.closest('.wrap-account-type');
                let $select2Elm = $wrapElm.find('.select2-container--bootstrap');
                $select2Elm.find('.select2-selection--single').addClass('has-error');
                $(`<span class='help-block'>${plan_errors[0]}</span>`).insertAfter($select2Elm);
              } else {
                $(`<span class='help-block'>${plan_errors[0]}</span>`).insertAfter($inputElement);
                $inputElement.addClass('has-error');
              }
            });
          }
        },
        error: function () {
          $submitBtn.prop('disabled', false);
        }
      });
    });

    function resetPlanForm() {
      let $planForm = $('.form-create-edit-plan');
      $planForm.find('.has-error').removeClass('has-error');
      $planForm.find('.help-block').remove();
    }

    $('.edit-plan').on('click', function () {
      let planId = $(this).closest('.wrap-control-plan-item').data('plan-id');
      $settingPlanModal.find('.title').text('予定編集');
      $settingPlanModal.find('.submit-plan-text').text('変更');
      $settingPlanModal.attr('project_account_plan_id', planId);
      $planForm.attr('method', 'PUT');

      $.ajax({
        url: `/projects/${PROJECT_ID}/project_account_plans/${planId}/load_plan_object`,
        method: 'GET',
        success: function (res) {
          let planData = res.project_account_plan;
          _.each(['account_type', 'account_at_format', 'amount'], function (field) {
            $(`#plan_${field}`).val(planData[field]);
          });
          reInitElm();
          $settingPlanModal.find('.js-save-account-plan').prop('disabled', false);
          $settingPlanModal.modal('show');
        },
      });
    });

    $('.destroy-plan').on('click', function () {
      let planId = $(this).closest('.wrap-control-plan-item').data('plan-id');
      $confirmDestroyPlanModal.attr('plan-id', planId);
      $confirmDestroyPlanModal.modal('show');
    });

    $('.js-confirm-destroy-plan').on('click', function () {
      let projectPlanId = $confirmDestroyPlanModal.attr('plan-id');

      $.ajax({
        url: `/projects/${PROJECT_ID}/project_account_plans/${projectPlanId}`,
        method: 'DELETE',
        success: function (res) {
          if (res.status) {
            window.location.href = `/projects/${PROJECT_ID}/edit`;
          }
        },
      });
    });

    function reInitElm() {
      $('#plan_account_type').select2({
        theme: 'bootstrap',
        placeholder: '選択してください',
        allowClear: true,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
      });
    }

    $('.js-search-plan').on('click', function () {
      let year = $('.input-year').val();
      let month = $('.input-month').val();
      if (
        !year ||
        !month ||
        _.toString(year).length != 4 ||
        _.toInteger(month) > 12 ||
        _.toInteger(month) < 1
      )
        return;

      let params = {
        search_month: `${year}/${month}/01`,
        is_search: true,
        year: year,
        month: month,
      };
      searchPlan(params);
    });

    $('.js-jump-to-plan').on('click', function () {
      var dataMonth = $(this).data('month');
      var currentMonth = $('.table-plan-result').data('current-month');

      let params = {
        current_month: currentMonth,
        is_search: true,
        step_month: _.toInteger(dataMonth),
      };
      searchPlan(params);
    });

    function searchPlan(params) {
      $.ajax({
        url: `/projects/${PROJECT_ID}/edit`,
        method: 'GET',
        contentType: 'application/json',
        dataType: 'json',
        data: params,
        success: function (res) {
          let searchParams = new URLSearchParams(res.search_params);
          window.location.href = `/projects/${PROJECT_ID}/edit?${searchParams.toString()}`;
        },
      });
    }

    $('#plan_amount').on('keydown', function (e) {
      let invalidChars = ["e"]
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    });

    $('.btn-custom-cancel').on('click', function () {
      $('#plan_account_type').val('').trigger('change');
      $('.form-create-edit-plan')[0].reset();
      $('.help-block').empty();
      $('.form-control').removeClass('has-error');
    });
  }

  // An existing project already has its 請求先 setting, so it counts as edited from the start.
  var $sendingPlaceField = $('#sending_place_id');
  $sendingPlaceField.data('userEdited', $sendingPlaceField.closest('form').find('input[name="_method"][value="patch"]').length > 0);
  $sendingPlaceField.on('change', function () {
    if (!$(this).data('autoFilling')) {
      $(this).data('userEdited', true);
    }
  });

  $(".sending-company-id").on("change", function() {
    var company_id = $(this).val();
    $.ajax({
      url: `/companies/${company_id}/load_sending_place`,
      method: 'get',
      success: function (res) {
        // $('#sending_place_id').find('option').remove();
        if ($("#project_project_type").val() == 'korabo' || $("input[name='project[project_type]']:checked").val() == 'korabo') {
          var $contactLocation = $('#project_contact_location');
          if (!$contactLocation.val()) {
            $contactLocation.val(res.address);
          }
        }
        // $.each(res.companies, function (i, item) {
        //   $('#sending_place_id').append($('<option>', {
        //     value: item[1],
        //     text : item[0]
        //   }));
        //   $('#sending_place_id').attr('disabled', false);
        //   $('#payment_type').val(res.payment_type).change();
        // });
        if (!$('#payment_type').val()) {
          var paymentType = isCashOrLeaseTransactionStatus(selectedTransactionStatus())
            ? 'transfer_deposit'
            : res.payment_type;
          $('#payment_type').val(paymentType).change();
        }
        var $sendingPlace = $('#sending_place_id');
        var currentId = $sendingPlace.val();
        if (canAutoFillSendingPlace(currentId, $sendingPlace.data('autoFilledId'), $sendingPlace.data('userEdited'))) {
          $sendingPlace.data('autoFilling', true);
          if (res.companies != null) {
            $sendingPlace.data('autoFilledId', res.companies.id);
            $sendingPlace.val(res.companies.id).change();
          } else if (currentId) {
            $sendingPlace.removeData('autoFilledId');
            $sendingPlace.val('').change();
          }
          $sendingPlace.data('autoFilling', false);
        }
      }
    })
  })

  if($('.datepicker').length > 0){
    $('.datepicker').datepicker({
      changeMonth: true,
      changeYear: true,
      showButtonPanel: false,
      dateFormat: 'mm/yy',
      onClose: function(dateText, inst) {
          var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
          var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
          $(this).datepicker('setDate', new Date(year, month, 1));
      }
    });
  }
});

function loadWorkers(departmentId) {
  $.ajax({
    url: "/projects/load_workers",
    method: "GET",
    data: { department_id: departmentId },
    success: function (res) {
      var workers = _.map(res.workers, function (worker) {
        return { id: worker.id, text: worker.fullname };
      })
      var managers = _.map(res.managers || [], function (worker) {
        return { id: worker.id, text: worker.fullname };
      })
      $(".project-page.assign-worker-id").html('').select2({ data: workers });
      $(".project-page.assign-worker-id").prop("disabled", false);
      $(".project-page.assign-worker-id").select2({
        theme: 'bootstrap',
        placeholder: '選択してください',
        allowClear: true,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
      });

      $("#assigned_worker_ids").html('').select2({ data: workers });
      $("#assigned_worker_ids").prop("disabled", false);
      $("#assigned_worker_ids").select2({
        theme: 'bootstrap',
        placeholder: '選択してください',
        allowClear: true,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
      });

      $(".estimate-sheet-acceptor-ids").html('').select2({ data: managers });
      $(".estimate-sheet-acceptor-ids").prop("disabled", false);
      $(".estimate-sheet-acceptor-ids").select2({
        theme: 'bootstrap',
        placeholder: '選択してください',
        allowClear: true,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
      });
      $(".estimate-sheet-acceptor-ids").trigger('change');
    },
  });
}

$(document).on('change', ".project-page.department-id", function () {
  var departmentId = $(this).val();
  $(".project-page.assign-worker-id").html('').select2({ data: [{ id: '', text: '' }] });
  $(".estimate-sheet-acceptor-ids").html('').select2({ data: [{ id: '', text: '' }] });
  if (departmentId) {
    loadWorkers(departmentId)
  } else {
    $(".project-page.assign-worker-id").prop("disabled", true);
    $(".estimate-sheet-acceptor-ids").prop("disabled", true);
  }
})


$(document).on('change', '#modal-create-bill-sheet #bill_sheet_status ', function () {
  var value = $(this).val();
  var notSendId = $("#bill_sheet_bill_no").data('not-send-id').toString()
  var editNotSend = notSendId.length > 0 && $('#bill_sheet_id').val() == notSendId
  var projectType = $("#project_project_type").val()

  if (!editNotSend && projectType != 'continue' && value == 'not_send' && (projectType == 'spot' || projectType == 'korabo')) {
    $('#modal-create-bill-sheet #error-message').removeClass('d-none');
    $('#modal-bill-sheet-submit').prop('disabled', true);
  } else {
    $('#modal-create-bill-sheet #error-message').addClass('d-none');
    $('#modal-bill-sheet-submit').prop('disabled', false);
  }
})

$(document).on('change', '#modal-create-bill-sheet #bill_sheet_pay_method ', function () {
  var value = $(this).val();
  let now = new Date();
  let formattedDate;
  if (value == 'transfer_deposit') {
    let endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    // if (now.getDate() === endOfMonth.getDate()) {
    //   endOfMonth = new Date(now.getFullYear(), now.getMonth() + 2, 0);
    // }
    endOfMonth = new Date(now.getFullYear(), now.getMonth() + 2, 0);
    formattedDate = endOfMonth.getFullYear() + '/' + (endOfMonth.getMonth() + 1).toString().padStart(2, '0') + '/' + endOfMonth.getDate().toString().padStart(2, '0');
  } else if (value == 'direct_debit') {
    nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 27);
    formattedDate = nextMonth.getFullYear() + '/' + (nextMonth.getMonth() + 1).toString().padStart(2, '0') + '/' + nextMonth.getDate().toString().padStart(2, '0');
  } else {
    if ($("#bill_sheet_expired_at").length > 0) {
      formattedDate = $("#bill_sheet_expired_at").val()
    } else {
      formattedDate = $("#get_deposit_date_id").val()
    }

  }
  $('#modal-create-bill-sheet #bill_sheet_deposit_date').val(formattedDate)
})

function isExpenseProjectType() {
  return ($('#project_project_type').val() || $("input[name='project[project_type]']:checked").val()) === 'expense';
}

function setSelect2DisabledState($select, disabled) {
  $select.prop('disabled', disabled);

  if (!$select.hasClass('select2-hidden-accessible')) return;

  var $container = $select.next('.select2-container');
  $container.toggleClass('select2-container--disabled', disabled);
  $container.find('.select2-selection')
    .attr('aria-disabled', disabled ? 'true' : 'false')
    .attr('tabindex', disabled ? '-1' : '0');

  if (disabled) {
    $select.select2('close');
  }
}

function syncPaymentPeriodFields(isExpense) {
  var $continueRadios = $('#project_payment_period_monthly, #project_payment_period_others');
  var $expenseRadios = $('#project_payment_period_monthly_expense, #project_payment_period_others_expense');
  var $continueMonths = $('#project_payment_period_months');
  var $expenseMonths = $('#project_payment_period_months_expense');

  if (!$expenseRadios.length) return;

  // Prefer the visible/active radio group so a stale hidden selection cannot win on submit.
  var selectedPeriod = isExpense
    ? ($expenseRadios.filter(':checked').val() || $continueRadios.filter(':checked').val() || 'monthly')
    : ($continueRadios.filter(':checked').val() || $expenseRadios.filter(':checked').val() || 'monthly');

  if (isExpense) {
    // Only seed expense from continue when expense is empty (e.g. type switch).
    // Never overwrite expense selections — submit was wiping newly chosen months.
    if ($continueMonths.length && $expenseMonths.length) {
      var expenseMonthsVal = $expenseMonths.val();
      var continueMonthsVal = $continueMonths.val();
      if ((!expenseMonthsVal || !expenseMonthsVal.length) && continueMonthsVal && continueMonthsVal.length) {
        $expenseMonths.val(continueMonthsVal).trigger('change');
      }
    }

    $continueRadios.prop({ checked: false, disabled: true }).attr('name', '');
    setSelect2DisabledState($continueMonths, true);
    $continueMonths.attr('name', '');

    $expenseRadios.prop('disabled', false).attr('name', 'project[payment_period]');
    $expenseRadios.filter('[value="' + selectedPeriod + '"]').prop('checked', true);
    setSelect2DisabledState($expenseMonths, false);
    $expenseMonths.attr('name', 'project[payment_period_months][]');
  } else {
    if ($continueMonths.length && $expenseMonths.length) {
      var activeContinueMonthsVal = $continueMonths.val();
      var sourceExpenseMonthsVal = $expenseMonths.val();
      if ((!activeContinueMonthsVal || !activeContinueMonthsVal.length) && sourceExpenseMonthsVal && sourceExpenseMonthsVal.length) {
        $continueMonths.val(sourceExpenseMonthsVal).trigger('change');
      }
    }

    $expenseRadios.prop({ checked: false, disabled: true }).attr('name', '');
    setSelect2DisabledState($expenseMonths, true);
    $expenseMonths.attr('name', '');

    $continueRadios.prop('disabled', false).attr('name', 'project[payment_period]');
    $continueRadios.filter('[value="' + selectedPeriod + '"]').prop('checked', true);
    setSelect2DisabledState($continueMonths, false);
    $continueMonths.attr('name', 'project[payment_period_months][]');
  }

  togglePaymentPeriodMonths();
}

function syncExpensePaymentFields(isExpense) {
  if (!$('#expense_payment_type').length) return;

  if (isExpense) {
    var val = $('#payment_type').val();
    if (val) {
      $('#expense_payment_type').val(val).trigger('change');
    }
    $('#payment_type').prop('disabled', true);
    $('#expense_payment_type').prop('disabled', false);
  } else {
    var expenseVal = $('#expense_payment_type').val();
    if (expenseVal) {
      $('#payment_type').val(expenseVal).trigger('change');
    }
    $('#expense_payment_type').prop('disabled', true);
    $('#payment_type').prop('disabled', false);
  }
}

function swapCompanySelectOptions(isExpense) {
  var $select = $('#client_company_id');
  if (!$select.length) return;

  var options = isExpense
    ? $select.data('partnerCompanyOptions')
    : $select.data('clientCompanyOptions');
  if (!options) return;

  if (typeof options === 'string') {
    options = JSON.parse(options);
  }

  var currentVal = $select.val();
  if ($select.hasClass('select2-hidden-accessible')) {
    $select.select2('destroy');
  }

  $select.empty();
  $select.append(new Option('', '', false, false));
  options.forEach(function (opt) {
    $select.append(new Option(opt[0], opt[1], false, false));
  });

  $select.select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: '選択してください',
    allowClear: true,
    language: {
      noResults: function () {
        return '見つかりません。';
      },
    },
  });

  if (currentVal && $select.find('option[value="' + currentVal + '"]').length) {
    $select.val(currentVal).trigger('change');
  } else {
    $select.val('').trigger('change');
  }
}

function setExpenseFormVisibility(isExpense) {
  if (!$('.project-field-expense').length) return;

  $('.project-field-expense').toggleClass('d-none', !isExpense);
  $('.project-field-expense :input').prop('disabled', !isExpense);
  $('.project-field-not-expense').toggleClass('d-none', isExpense);
  $('.project-field-not-expense :input').prop('disabled', isExpense);
  $('.project-field-client-label').toggleClass('d-none', isExpense);
  $('.project-field-expense-label').toggleClass('d-none', !isExpense);

  if (isExpense) {
    $('#note_expense').prop('name', 'project[note]');
    $('#note_spot').prop('name', '');
    $('#note_continue').prop('name', '');
  }

  syncPaymentPeriodFields(isExpense);
  syncExpensePaymentFields(isExpense);
  swapCompanySelectOptions(isExpense);

  if (isExpense) {
    $('#project_payment_period_monthly_expense, #project_payment_period_others_expense').prop('disabled', false);
    setSelect2DisabledState($('#project_payment_period_months_expense'), false);
    togglePaymentPeriodMonths();
  } else {
    togglePaymentPeriodMonths();
  }
}

function selectedTransactionStatus() {
  return $("input[name='project[transaction_status]']:checked").val();
}

function isCashOrLeaseTransactionStatus(status) {
  return status === 'cash' || status === 'lease';
}

function applyPaymentTypeDefaultForTransactionStatus() {
  if (!isCashOrLeaseTransactionStatus(selectedTransactionStatus())) return;

  var $paymentType = $('#payment_type');
  if (!$paymentType.length || $paymentType.prop('disabled')) return;

  $paymentType.val('transfer_deposit').trigger('change');
}

function isNewProjectForm() {
  var formId = $('form.form-project').attr('id') || '';
  return formId === 'new_project';
}

$(document).on('change', "input[name='project[transaction_status]']", function () {
  applyPaymentTypeDefaultForTransactionStatus();
});

function setKoraboAmountFieldState($input, enabled) {
  if (!$input.length) return;

  if (enabled) {
    $input.prop('disabled', false);
  } else {
    $input.val('').prop('disabled', true);
  }
}

function syncKoraboConditionalAmountFields() {
  var projectType = $('#project_project_type').val() || $("input[name='project[project_type]']:checked").val();
  var $basicFeeAmount = $('#korabo_basic_fee_amount');
  var $phoneDiscountAmount = $('#korabo_phone_discount_amount');

  if (projectType !== 'korabo') {
    setKoraboAmountFieldState($basicFeeAmount, false);
    setKoraboAmountFieldState($phoneDiscountAmount, false);
    return;
  }

  var basicFeeEnabled = $('#korabo_basic_fee_override_enabled').is(':checked');
  var phoneDiscountEnabled = $('#korabo_phone_discount_enabled').is(':checked');

  setKoraboAmountFieldState($basicFeeAmount, basicFeeEnabled);
  setKoraboAmountFieldState($phoneDiscountAmount, phoneDiscountEnabled);
}

function showFieldByProjectType(projectType = undefined) {
  projectType = projectType || $("input[name='project[project_type]']:checked").val() || $('#project_project_type').val();

  const setNonSpotNoteLayout = (isKorabo) => {
    $('#project-note-cell').attr('colspan', isKorabo ? 3 : 1);
    $('.not-korabo-note-side').toggleClass('d-none', isKorabo);
    $('#note_continue').attr('maxlength', isKorabo ? 120 : null);
  };

  if (projectType == 'expense') {
    setExpenseFormVisibility(true);
    $('.is-korabo').addClass('d-none');
    $('.is-korabo :input').prop('disabled', true);
    $('.is-continue').addClass('d-none');
    $('.is-continue :input').prop('disabled', true);
    $('.is-spot').addClass('d-none');
    $('.is-spot :input').prop('disabled', true);
    $('.not-spot').addClass('d-none');
    $('.not-spot :input').prop('disabled', true);
    $('#name').prop('disabled', false);
    $('#status').prop('disabled', false);
    if ($('.new_project').length > 0 && $('#department_id').val().length > 0) {
      loadWorkers($('#department_id').val())
    }
  } else if (projectType == 'spot') {
    setExpenseFormVisibility(false);
    $('.is-korabo').addClass('d-none');
    $('.is-korabo :input').prop('disabled', true);
    $('.not-korabo').removeClass('d-none');
    $('.is-continue').addClass('d-none');
    $('.is-continue :input').prop('disabled', true);
    $('.is_parent_container').removeClass('d-none');
    $('.pj_name_container .project_name').removeClass('w-100');
    $('#note_spot').prop('name', 'project[note]');
    $('#note_continue').prop('name', '');
    setNonSpotNoteLayout(false);
    $('.not-spot').addClass('d-none');
    $('[data-cell-multi-fields]').removeClass('cell-multi-fields');
    $('.is-spot').removeClass('d-none');
    // Enable PJ field and reset value for non-korabo projects
    $('#name').prop('disabled', false);
    $('.new_project #name').val('');
    // if ($('form.edit_project').length == 0) {
    //   $('#status').val('not_start').change();
    // }
    $('#status').prop('disabled', false);
    if ($('.new_project').length > 0 && $('#department_id').val().length > 0) {
      loadWorkers($('#department_id').val())
    }
  } else if (projectType == 'continue') {
    setExpenseFormVisibility(false);
    $('.is-continue :input').prop('disabled', false)
    $('.is-korabo').addClass('d-none');
    $('.is-korabo :input').prop('disabled', true);
    $('.not-korabo').removeClass('d-none');
    // $('.not-spot.is-korabo').removeClass('d-none');
    $('.is_parent_container').removeClass('d-none');
    $('.pj_name_container .project_name').removeClass('w-100');
    $('#note_continue').prop('name', 'project[note]');
    $('#note_spot').prop('name', '');
    setNonSpotNoteLayout(false);
    $('[data-cell-multi-fields]').addClass('cell-multi-fields');
    $('.is-spot').addClass('d-none');
    $('.not-spot').removeClass('d-none');
    $('.is-continue').removeClass('d-none');
    // Enable PJ field and reset value for non-korabo projects
    $('#name').prop('disabled', false);
    $('.new_project #name').val('');
    // $('#status').val('inprogress').change();
    if ($('.new_project').length > 0 && $('#department_id').val().length > 0) {
      loadWorkers($('#department_id').val())
    }
  } else if (projectType == 'korabo') {
    setExpenseFormVisibility(false);
    $('.is-korabo :input').prop('disabled', false);
    $('#name').val('ミライク光');
    $('#name').prop('disabled', true);
    $('.not-spot').removeClass('d-none');
    $('.is-continue').addClass('d-none');
    $('.is-continue :input').prop('disabled', true);
    $('.is-spot').addClass('d-none');
    $('#note_continue').prop('name', 'project[note]');
    $('#note_spot').prop('name', '');
    setNonSpotNoteLayout(true);
    $('.not-korabo').addClass('d-none');
    $('.is_parent_container').addClass('d-none');
    $('.pj_name_container .project_name').addClass('w-100');
    $('.is-korabo').removeClass('d-none');
    $('[data-cell-multi-fields]').removeClass('cell-multi-fields');
    // $('#status').val('inprogress').change();
    $('#status').prop('disabled', false);
    if ($('.new_project').length > 0) {
      loadWorkers()
    }
  }

  syncKoraboConditionalAmountFields();
}

$(document).on('change', '#korabo_basic_fee_override_enabled, #korabo_phone_discount_enabled', syncKoraboConditionalAmountFields);

$(document).on('change', "input[name='project[project_type]']", function() {
  var projectType = $("input[name='project[project_type]']:checked").val()
  var newOptions = {}
  if (projectType == 'korabo') {
    newOptions = {
      "inprogress": "受注・推進中",
      "not_yet_billing": "未請求",
      "billing": "請求",
      "billing_done": "請求済",
      "done": "完了",
      "lost_order": "失注",
    };
  } else if( projectType == 'continue') {
    newOptions = {
      "inprogress": "受注・推進中",
      "not_yet_billing": "未請求",
      "billing": "請求",
      "billing_done": "請求済",
      "done": "完了",
      "lost_order": "失注",
    };
  } else {
    newOptions = {
      "not_start": "未着手",
      "inprogress": "受注・推進中",
      "not_yet_billing": "未請求",
      "billing": "請求",
      "a_part_billing": "一部請求済・請求済",
      "done": "完了",
      "lost_order": "失注",
    };
  }

  if (projectType == 'spot') {
    $('#transaction-continue').addClass('d-none');
    $('#transaction-continue').find('input').attr('disabled', true);
    $('#transaction-spot').removeClass('d-none');
    $('#transaction-spot').find('input').attr('disabled', false);
    $('#transaction-spot').find('input[value=cash]').prop('checked', true).trigger('change');
    $('.is_parent_desc').show();
  } else if (projectType != 'expense') {
    $('#transaction-spot').addClass('d-none');
    $('#transaction-spot').find('input').attr('disabled', true);
    $('#transaction-continue').removeClass('d-none');
    $('#transaction-continue').find('input').attr('disabled', false).removeClass('disabled');
    $('#transaction-continue').find('div').removeClass('disabled');
    $('#transaction-continue').find('input').prop('checked', true).trigger('change');
    $('.is_parent_desc').hide();
  }

  $('.project_status_korabo').children().remove()
  var select = $('.project_status_korabo');
  $.each(newOptions, function(text, key) {
      var option = new Option(key, text);
      select.append($(option));
  });

  showFieldByProjectType()
  applyPaymentTypeDefaultForTransactionStatus()
  setSpotCompletionDate()
})

function todayDateText() {
  var today = new Date();
  var month = String(today.getMonth() + 1).padStart(2, '0');
  var day = String(today.getDate()).padStart(2, '0');
  return today.getFullYear() + '/' + month + '/' + day;
}

function setSpotCompletionDate() {
  if (!$('form.form-project').length) return;

  var projectType = $("input[name='project[project_type]']:checked").val() || $('#project_project_type').val();
  var $deliverAt = $('#deliver_at');
  if (!$deliverAt.length) return;

  if (projectType === 'spot' && $('#status').val() === 'done') {
    if ($deliverAt.val()) return;

    var todayText = todayDateText();
    $deliverAt.val(todayText);
    var picker = $deliverAt.data('daterangepicker');
    if (picker) {
      picker.setStartDate(todayText);
      picker.setEndDate(todayText);
    }
    $deliverAt.closest('.input-clearable').find('.clear-icon').css('display', 'inline');
    return;
  }

  $deliverAt.val('');
  $deliverAt.closest('.input-clearable').find('.clear-icon').hide();
}

$(document).on('change', 'form.form-project #status', setSpotCompletionDate);

// TODO run befor show page
$(function () {
  if ($('.form-project').length > 0) {
    var projectType = $('#project_project_type').val() || $("input[name='project[project_type]']:checked").val();
    showFieldByProjectType(projectType)
    if (isNewProjectForm()) {
      applyPaymentTypeDefaultForTransactionStatus();
    }
  }
})

function togglePaymentPeriodMonths() {
  var isExpense = isExpenseProjectType();
  var val;

  if (isExpense) {
    val = $('#project_payment_period_monthly_expense:checked, #project_payment_period_others_expense:checked').val();
  } else {
    val = $('#project_payment_period_monthly:checked, #project_payment_period_others:checked').val();
  }

  var $months = isExpense ? $('#project_payment_period_months_expense') : $('#project_payment_period_months');
  if (!$months.length) return;

  if (val === 'monthly' || !val) {
    setSelect2DisabledState($months, true);
    $months.val(null).trigger('change.select2');
  } else {
    setSelect2DisabledState($months, false);
    $months.trigger('change.select2');
  }
}

$(document).on('change', "input[name='project[payment_period]']", togglePaymentPeriodMonths);

$(document).on('select2:opening', '#project_payment_period_months, #project_payment_period_months_expense', function (event) {
  var isExpenseField = this.id === 'project_payment_period_months_expense';
  var selectedPeriod = isExpenseField
    ? $('#project_payment_period_monthly_expense:checked, #project_payment_period_others_expense:checked').val()
    : $('#project_payment_period_monthly:checked, #project_payment_period_others:checked').val();

  if ($(this).prop('disabled') || selectedPeriod === 'monthly' || !selectedPeriod) {
    event.preventDefault();
  }
});

$(document).on('change', "#contract_start_at", function () {
  var value = $(this).val();
  $("#billing_start_month").val(value);
})

$(document).on('click', ".js-modal-bill-sheet-month", function () {
  $('#modal-choose-bill-sheet-month').modal("show");
})

$(document).on('click', "#choose-bill-sheet-month-submit", function () {
  var url = $('.new-bill-with-month').attr('href');
  url = url + '&bill_sheet_month=' + $('#bill_sheet_month').val()
  $('.new-bill-with-month').attr('href', url);
})

$(document).on('click', "#modal-choose-bill-sheet-month .clear-icon", function () {
  var url = $('.new-bill-with-month').attr('href');
  url = url + '&bill_sheet_month='
  $('.new-bill-with-month').attr('href', url);
  $('#choose-bill-sheet-month-submit').prop('disabled', this.value ? false : true);
})


$(document).on('hide.bs.modal', '#modal-choose-bill-sheet-month', function() {
  var currentdate = new Date()
  var year = currentdate.getFullYear()
  var month = currentdate.getMonth() + 1
  $(this).find('.error-message').addClass("hidden");
  $('#modal-choose-bill-sheet-month input.singledate-month-year').data('daterangepicker').setStartDate(year + '/' + month);
})

const ele_singledate = () => {
  const ele = $('.project_deliver_at .singledate');
  const ele_project_completed_at = $('.project_completed_at .singledate');
  const ele_estimated_deliver_at = $('#estimated_deliver_at');

  if ($('#is-parent').is(':checked')) {
    ele.prop('disabled', true)
    ele_project_completed_at.prop('disabled', true)
    ele_estimated_deliver_at.prop('disabled', true)
  } else {
    ele.prop('disabled', false)
    ele_project_completed_at.prop('disabled', false)
    ele_estimated_deliver_at.prop('disabled', false)

  }
}

$(document).on('change', "#is-parent", function() {
  ele_singledate()
  const project_id = $(this).data('project-id');
  $.ajax({
    url: `/projects/${project_id}/update_is_parent`,
    type: 'PUT',
    data: { is_parent: $(this).is(':checked') },
    dataType: 'json',

    success: function(response) {
      if(response.status) {
        alert('保存に成功しました。');
        if($('#is-parent').is(':checked')) {
          $('.checked-final').prop('disabled', false);
        } else {
          if(response.number_ordered >= 1) {
            $('.checked-final').prop('disabled', true);
          } else {
            $('.checked-final').prop('disabled', false);
          }
        }
        $('#is-parent').prop('disabled', !response.can_change_type)
      }
    },
  })
})

$(function () {
  if ($('#is-parent').length > 0) {
    ele_singledate()
  }
})

$(document).on('change', '#bill_sheet_pay_method', function() {
  if($(this).val() === 'transfer_debit' || $(this).val() === 'transfer_deposit' || $(this).val() === 'transfer_subsidy'){
    $('.input-bank-account').show();
  } else {
    $('.input-bank-account').hide();
    $('#bill_sheet_bank_account_id').val('').change();
  }
})


$(document).ready(function () {
  function updateStatusOptions(projectType) {
    const $statusSelect = $('#q_status_eq');
    const selectedStatus = $statusSelect.val() || new URLSearchParams(window.location.search).get('q[status_eq]');

    $.ajax({
      url: '/projects/change_status_by_project_type',
      method: 'GET',
      data: { project_type: projectType },
      success: function (response) {
        $statusSelect.empty();

        $statusSelect.append($('<option>', {
          value: '',
          text: '-- Select Status --'
        }));

        response.statuses.forEach(function (status) {
          $statusSelect.append($('<option>', {
            value: status.key,
            text: status.name
          }));
        });


        if ($statusSelect.find('option').filter(function() {
              return $(this).val() === selectedStatus;
            }).length) {
          $statusSelect.val(selectedStatus);
        } else {
          $statusSelect.val('');
        }

        if ($statusSelect.hasClass('select2')) {
          $statusSelect.trigger('change');
        }
      },
      error: function () {
        alert('Failed to fetch statuses.');
      }
    });
  }

  $('.project-type-radio').on('change', function () {
    const projectType = $(this).val();
    updateStatusOptions(projectType);
  });

  const $selectedRadio = $('.project-type-radio:checked');
  if ($selectedRadio.length) {
    updateStatusOptions($selectedRadio.val());
  }

  $('.form-project').on('submit', function() {
    var $form = $(this);
    var $submitBtn = $form.find('button[type="submit"]');

    if ($form.data('submitted') === true) {
      return false;
    }


    var $nameField = $('#name');
    if ($nameField.prop('disabled')) {
      $nameField.prop('disabled', false);
    }

    if (isExpenseProjectType()) {
      syncPaymentPeriodFields(true);
    }

    $form.data('submitted', true);
    $submitBtn.prop('disabled', true);
    $submitBtn.text('処理中...');

    setTimeout(function() {
      if ($form.length && $form.is(':visible')) {
        $form.data('submitted', false);
        $submitBtn.prop('disabled', false);
        $submitBtn.text('登録');
      }
    }, 5000);
  });

  togglePaymentPeriodMonths();
});

function formatExpensePaymentCurrency(amount) {
  var value = Math.round(parseFloat(amount) || 0);
  return '¥ ' + value.toLocaleString('ja-JP');
}

function initExpensePaymentContentTaxRateSelect2() {
  var $taxRate = $('#expense-payment-content-modal .js-expense-payment-tax-rate');
  if (!$taxRate.length) return;

  if ($taxRate.hasClass('select2-hidden-accessible')) {
    $taxRate.select2('destroy');
  }

  $taxRate.select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: '選択してください',
    allowClear: true,
    minimumResultsForSearch: Infinity,
    dropdownParent: $('#expense-payment-content-modal')
  });
}

function showExpensePaymentContentFieldError($inputElement, message) {
  var $field = $inputElement.closest('.expense-payment-content-field');
  if (!$field.length) return;

  $field.find('.help-block').remove();

  if ($inputElement.hasClass('select2-hidden-accessible')) {
    $inputElement.next('.select2-container').find('.select2-selection--single').addClass('has-error');
  } else if ($inputElement.closest('.field-has-icon-yen').length) {
    $inputElement.addClass('has-error');
  } else {
    $inputElement.addClass('has-error');
  }

  $field.append($("<span class='help-block'></span>").text(message));
}

function validateExpensePaymentContentForm() {
  var $form = $('#form-create-expense-payment-content');
  if (!$form.length) return false;

  var isValid = true;
  var requiredMessage = 'この項目は必須です。';

  var $item = $form.find('#expense_payment_content_item');
  if (!$item.val() || !$item.val().toString().trim()) {
    isValid = false;
    showExpensePaymentContentFieldError($item, requiredMessage);
  }

  var $excludingTax = $form.find('.js-expense-payment-excluding-tax');
  var excludingTaxValue = $excludingTax.val();
  if (excludingTaxValue === null || excludingTaxValue === undefined || excludingTaxValue.toString().trim() === '') {
    isValid = false;
    showExpensePaymentContentFieldError($excludingTax, requiredMessage);
  }

  var $taxRate = $form.find('.js-expense-payment-tax-rate');
  var taxRateValue = $taxRate.val();
  if (taxRateValue === null || taxRateValue === undefined || taxRateValue === '') {
    isValid = false;
    showExpensePaymentContentFieldError($taxRate, requiredMessage);
  }

  return isValid;
}

function updateExpensePaymentTaxInclusiveAmount() {
  var $form = $('#form-create-expense-payment-content');
  if (!$form.length) return;

  var excluding = parseFloat($form.find('.js-expense-payment-excluding-tax').val()) || 0;
  var rate = parseFloat($form.find('.js-expense-payment-tax-rate').val()) || 0;
  var inclusive = Math.round(excluding * (1 + rate));
  $form.find('.js-expense-payment-tax-inclusive-display').val(formatExpensePaymentCurrency(inclusive));
}

function clearExpensePaymentContentFormErrors() {
  var $form = $('#form-create-expense-payment-content');
  if (!$form.length) return;

  $form.find('.has-error').removeClass('has-error');
  $form.find('.help-block').remove();
  $form.find('.select2-container--bootstrap .select2-selection--single').removeClass('has-error');
}

function resetExpensePaymentContentForm() {
  var $form = $('#form-create-expense-payment-content');
  if (!$form.length) return;

  clearExpensePaymentContentFormErrors();
  $form.find('#expense_payment_content_item').val('');
  $form.find('.js-expense-payment-excluding-tax').val('');
  $form.find('#expense_payment_content_remarks').val('');
  $form.find('.js-expense-payment-tax-rate').val('0.1').trigger('change');
  updateExpensePaymentTaxInclusiveAmount();
  setExpensePaymentContentModalMode(null);
}

function setExpensePaymentContentModalMode(contentId) {
  var $modal = $('#expense-payment-content-modal');
  $modal.data('expense-payment-content-id', contentId || '');
  $('#expense-payment-content-modal-title b').text(contentId ? '支払項目編集' : '支払項目作成');
}

function expensePaymentProjectId() {
  var projectId = $('.table-plan-result').data('project-id');
  if (projectId) return projectId;

  var match = window.location.pathname.match(/\/projects\/(\d+)/);
  return match ? match[1] : null;
}

$(document).on('click', '.js-open-expense-payment-content-modal', function () {
  resetExpensePaymentContentForm();
  $('#expense-payment-content-modal').modal('show');
});

$(document).on('click', '.js-edit-expense-payment-content', function (e) {
  e.preventDefault();

  var contentId = $(this).data('id');
  var projectId = expensePaymentProjectId();
  if (!projectId || !contentId) return;

  $.get('/projects/' + projectId + '/expense_payment_contents/' + contentId + '/load_object', function (res) {
    var data = res.expense_payment_content;
    clearExpensePaymentContentFormErrors();

    var $form = $('#form-create-expense-payment-content');
    $form.find('#expense_payment_content_item').val(data.item);
    $form.find('.js-expense-payment-excluding-tax').val(Math.round(parseFloat(data.excluding_tax) || 0));
    $form.find('#expense_payment_content_remarks').val(data.remarks || '');

    var rate = parseFloat(data.tax_rate) || 0;
    var $taxRate = $form.find('.js-expense-payment-tax-rate');
    $taxRate.find('option').each(function () {
      if (parseFloat($(this).val()) === rate) {
        $taxRate.val($(this).val()).trigger('change');
        return false;
      }
    });

    updateExpensePaymentTaxInclusiveAmount();
    setExpensePaymentContentModalMode(contentId);
    $('#expense-payment-content-modal').modal('show');
  });
});

$(document).on('shown.bs.modal', '#expense-payment-content-modal', function () {
  initExpensePaymentContentTaxRateSelect2();
  updateExpensePaymentTaxInclusiveAmount();
});

$(document).on('select2:clear', '#expense-payment-content-modal .js-expense-payment-tax-rate', function () {
  $(this).val('').trigger('change');
});

$(document).on('input change', '.js-expense-payment-excluding-tax, .js-expense-payment-tax-rate', function () {
  updateExpensePaymentTaxInclusiveAmount();
});

$(document).on('click', '.js-save-expense-payment-content', function () {
  var $form = $('#form-create-expense-payment-content');
  if (!$form.length) return;

  var $btn = $(this);
  if ($btn.prop('disabled')) return;

  clearExpensePaymentContentFormErrors();

  if (!validateExpensePaymentContentForm()) return;

  $btn.prop('disabled', true);

  var contentId = $('#expense-payment-content-modal').data('expense-payment-content-id');
  var projectId = expensePaymentProjectId();
  var url = contentId
    ? '/projects/' + projectId + '/expense_payment_contents/' + contentId
    : $form.attr('action');
  var method = contentId ? 'PUT' : 'POST';

  $.ajax({
    url: url,
    method: method,
    data: $form.serialize(),
    success: function (res) {
      if (res.status) {
        window.location.href = `/projects/${projectId}/edit?current_tab=expense-payment-content-tab`;
        return;
      }

      _.each(res.errors, function (fieldErrors, attr) {
        var $inputElement = $form.find("[name='expense_payment_content[" + attr + "]']");
        if (!$inputElement.length) return;
        showExpensePaymentContentFieldError($inputElement, fieldErrors[0]);
      });
      $btn.prop('disabled', false);
    },
    error: function () {
      $btn.prop('disabled', false);
    }
  });
});
